import * as Yup from 'yup';
import { isValidNip } from '../../helpers/validation';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    employerType: Yup.string().nullable().required('Pole wymagane'),
    employerCompanyName: Yup.string()
        .when('employerType', {
            is: 'Pracownik w firmie zagranicznej',

            then: Yup.string().required('Pole wymagane'),
        })
        .when('employerType', {
            is: 'Student / uczeń',

            then: Yup.string().required('Pole wymagane'),
        }),
    nip: Yup.array()
        .when('employerType', {
            is: 'Pracownik - osoba cywilna',
            then: Yup.array()
                .of(
                    Yup.object().shape({
                        value: Yup.string()
                            .test('nip', 'Nieprawidłowy NIP', (value) => isValidNip(value))
                            .test('nip', 'Prosimy o usunięcie spacji w polu NIP', (value) => {
                                if (value.includes(' ')) {
                                    return false;
                                }
                                return true;
                            }),
                    }),
                )
                .required('Pole wymagane'),
            otherwise: Yup.array().notRequired(),
        })
        .when('employerType', {
            is: 'Pracownik służb mundurowych',
            then: Yup.array()
                .of(
                    Yup.object().shape({
                        value: Yup.string().test('nip', 'Nieprawidłowy NIP', (value) =>
                            isValidNip(value),
                        ),
                    }),
                )
                .required('Pole wymagane'),
            otherwise: Yup.array().notRequired(),
        }),
    dateOfIllness: Yup.string().required('Pole wymagane').nullable(),
    dateOfBackToWork: Yup.string().required('Pole wymagane').nullable(),
    importantInformation: Yup.string().required('Pole wymagane'),
    ...sharedSchema,
});
